import React from 'react';
import personasInicio from '../../../assets/personasInicio.jpg';
import Button from '../../Button';
import { useNavigate } from "react-router-dom";

const HeroSection = () => {
  const navigate = useNavigate();

  return (
    <section className="relative w-full min-h-[420px] md:min-h-[550px] lg:min-h-[750px] flex items-end py-12 overflow-hidden">
      <div
        className="absolute inset-0 w-full h-full bg-cover bg-center"
        style={{
          backgroundImage: `url(${personasInicio})`,
          backgroundPosition: '0% 30%'
        }}
      />
      <div className="absolute inset-0 bg-black/40 lg:bg-black/20" />
      <div className="relative z-10 w-full flex justify-center lg:justify-start px-6 sm:px-10 lg:px-16">
        <div className="max-w-5xl flex flex-col gap-6 text-center lg:text-left">
          <h1 className="text-white text-3xl sm:text-4xl lg:text-6xl font-extrabold leading-tight tracking-wide" style={{ textShadow: '2px 2px 15px rgba(0,0,0,1)' }}>
            <span className="block">Compara, elige y gestiona</span>
            <span className="block">tus productos financieros</span>
            <span className="text-4xl sm:text-5xl lg:text-7xl block">¡En un solo lugar!</span>
          </h1>
          <div className="flex justify-center lg:justify-start">
            <Button
              text="¡Vincula tus finanzas!"
              color="bg-[#276ae8]"
              textColor="text-white"
              paddingX="px-10 sm:px-12"
              paddingY="py-2"
              textSize="text-base sm:text-lg font-bold"
              border="border-transparent"
              disableHover={false}
              rounded="rounded-3xl"
              fullWidth={false}
              onClick={() => navigate("/vincula-tus-finanzas")}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
